import { render, staticRenderFns } from "./VoucherCpfPointsLimit.vue?vue&type=template&id=3a3803b9"
import script from "./VoucherCpfPointsLimit.vue?vue&type=script&lang=js"
export * from "./VoucherCpfPointsLimit.vue?vue&type=script&lang=js"
import style0 from "./VoucherCpfPointsLimit.vue?vue&type=style&index=0&id=3a3803b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports